import { Component, Input, OnInit } from '@angular/core';
import { CommentService } from '../';
import { Comment, User } from '../../models/';
import { ConfigService } from '../services/config.service';
import { MomentModule } from 'ngx-moment';
import { UserIdToNamePipe } from '../pipes/user-id-to-name.pipe';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { MatFormField } from '@angular/material/form-field';
import { MatFabButton, MatButton } from '@angular/material/button';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-comments',
    templateUrl: './comments.component.html',
    styleUrls: ['./comments.component.css'],
    providers: [CommentService],
    standalone: true,
    imports: [NgIf, FlexModule, MatFabButton, MatFormField, MatInput, ReactiveFormsModule, FormsModule, MatButton, NgFor, AsyncPipe, UserIdToNamePipe, MomentModule]
})
export class CommentsComponent implements OnInit {
  @Input()
  public type;

  @Input()
  public id;

  @Input()
  public comments?: Comment[] = [];

  dateTimeFormat = ConfigService.dates.longDateTimeFormat;

  currentUser: User;
  public newComment: any = { comment: '' };

  constructor(
    private commentService: CommentService,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.configService.currentUser.subscribe((loggedInUSer) => {
      this.currentUser = loggedInUSer;
    });
  }

  add() {
    this.newComment.commentable_type = this.type;
    this.newComment.commentable_id = this.id;
    this.newComment.user_id = this.currentUser.id;
    this.newComment.deleted = 0;
    delete this.newComment.user;
    this.commentService.create(this.newComment).subscribe((response) => {
      let comment = response;
      comment.user = this.currentUser;
      if (this.comments) {
        this.comments.unshift(comment);
      } else {
        this.comments = [comment];
      }
      this.newComment.comment = '';
    });
  }
}
